import React from 'react';
import useStyle from './notificationsEntry.style';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';

export interface NotificationsEntryProps {
  contentText: string;
  link?: {
    name: string;
    url: string;
    button: boolean;
  };
}

export const NotificationsEntry = ({
  contentText,
  link
}: NotificationsEntryProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      {contentText && <p className={classes.text}>{contentText}</p>}
      {link &&
        (link.button ? (
          <div className={classes.link}>
            <ButtonWithText
              variant="primaryBlue"
              content={link.name}
              onClick={() => window.open(link.url, '_blank')}
            />
          </div>
        ) : (
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            {link.name}
          </a>
        ))}
    </div>
  );
};
